import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/rating-criterias';

export const FETCH_RATING_CRITERIA_DETAILS = defineApiActionTypes(
  `${prefix}/FETCH_RATING_CRITERIA_DETAILS`
);
